export function onlyDigits(value) {
  return (value ?? "").replace(/\D/g, "");
}

export function maskCpfCnpj(value) {
  const digits = onlyDigits(value);

  if (digits.length <= 11) {
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 9);
    const part4 = digits.slice(9, 11);
    return (
      [part1, part2, part3].filter(Boolean).join(".") +
      (part4 ? `-${part4}` : "")
    );
  }

  const part1 = digits.slice(0, 2);
  const part2 = digits.slice(2, 5);
  const part3 = digits.slice(5, 8);
  const part4 = digits.slice(8, 12);
  const part5 = digits.slice(12, 14);
  return (
    [part1, part2, part3].filter(Boolean).join(".") +
    (part4 ? `/${part4}` : "") +
    (part5 ? `-${part5}` : "")
  );
}

export function validateCPF(cpf) {
  if (!cpf || cpf.length !== 11) return false;
  if (/^(\d)\1+$/.test(cpf)) return false;

  let sum = 0;
  let remainder;

  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cpf[i - 1]) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf[9])) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cpf[i - 1]) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf[10])) return false;

  return true;
}

export function validateCNPJ(cnpj) {
  if (!cnpj) return false;
  const str = onlyDigits(cnpj);
  if (str.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(str)) return false;

  const calcDigit = (slice, weights) => {
    const sum = slice.reduce((acc, d, i) => acc + Number(d) * weights[i], 0);
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
  };

  const nums = str.split("");
  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const d1 = calcDigit(nums.slice(0, 12), weights1);
  if (d1 !== Number(nums[12])) return false;

  const d2 = calcDigit(nums.slice(0, 13), weights2);
  return d2 === Number(nums[13]);
}

export function isValidCpfCnpj(value) {
  const digits = onlyDigits(value);
  if (digits.length === 11) return validateCPF(digits);
  if (digits.length === 14) return validateCNPJ(digits);
  return false;
}
